import { render, staticRenderFns } from "./PostModal.vue?vue&type=template&id=6a9f615a&"
import script from "./PostModal.vue?vue&type=script&lang=js&"
export * from "./PostModal.vue?vue&type=script&lang=js&"
import style0 from "./PostModal.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports